<template>
  <RouterView />
  <ToastViewport />
</template>

<script setup lang="ts">
import ToastViewport from '@/components/feedback/ToastViewport.vue'
</script>
